import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
    selectSubreddit,
    fetchPostsIfNeeded,
    invalidateSubreddit
} from '../redux/actions/actions'
import Picker from '../components/reddit/Picker'
import Posts from '../components/reddit/Posts'
import './AsyncApp.css'

class AsyncApp extends Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleRefreshClick = this.handleRefreshClick.bind(this)
    }

    componentDidMount() {
        const { dispatch, selectedSubreddit } = this.props
        dispatch(fetchPostsIfNeeded(selectedSubreddit))
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedSubreddit !== prevProps.selectedSubreddit) {
            const { dispatch, selectedSubreddit } = this.props
            dispatch(fetchPostsIfNeeded(selectedSubreddit))
        }
    }

    handleChange(nextSubreddit) {
        this.props.dispatch(selectSubreddit(nextSubreddit))
        this.props.dispatch(fetchPostsIfNeeded(nextSubreddit))
    }

    handleRefreshClick(e) {
        e.preventDefault()

        const { dispatch, selectedSubreddit } = this.props
        dispatch(invalidateSubreddit(selectedSubreddit))
        dispatch(fetchPostsIfNeeded(selectedSubreddit))
    }

    render() {
        const { selectedSubreddit, posts, isFetching, lastUpdated } = this.props
        return (
            <div className="d-flex flex-wrap">
                <Picker
                    value={selectedSubreddit}
                    onChange={this.handleChange}
                    options={['technews', 'uknews']}
                />
                <p>
                    {lastUpdated &&
                        <span className="lastUpdated">
                            Last updated at {new Date(lastUpdated).toLocaleTimeString()}.
              {' '}
                            {!isFetching &&
                                <a href="#" onClick={this.handleRefreshClick}>
                                    Refresh
            </a>}
                        </span>}
                </p>
                {isFetching && posts.length === 0 && <h2 className="status">Loading...</h2>}
                {!isFetching && posts.length === 0 && <h2 className="status">Empty.</h2>}
                {posts.length > 0 &&
                    <div style={{ opacity: isFetching ? 0.5 : 1 }}>
                        <Posts posts={posts} />
                    </div>}
            </div>
        )
    }
}

AsyncApp.propTypes = {
    selectedSubreddit: PropTypes.string.isRequired,
    posts: PropTypes.array.isRequired,
    isFetching: PropTypes.bool.isRequired,
    lastUpdated: PropTypes.number,
    dispatch: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    const { selectedSubreddit, postsBySubreddit } = state
    const {
    isFetching,
        lastUpdated,
        items: posts
  } = postsBySubreddit[selectedSubreddit] || {
            isFetching: true,
            items: []
        }

    return {
        selectedSubreddit,
        posts,
        isFetching,
        lastUpdated
    }
}

export default connect(mapStateToProps)(AsyncApp)


// WEBPACK FOOTER //
// ./src/containers/AsyncApp.js